module.exports = __webpack_public_path__ + "img/组5391@2x.5636b777.png";